import * as React from "react";
import { IconProps } from "./IconProps";

export const IconQuestionMark = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <g clipPath="url(#clip0_14159_31522)">
          <path
            d="M8.00016 16C7.65404 16 7.3157 15.8976 7.02791 15.7057C6.74013 15.5139 6.51583 15.2412 6.38337 14.9221C6.25092 14.6031 6.21626 14.252 6.28379 13.9133C6.35131 13.5746 6.51798 13.2634 6.76273 13.0193C7.00747 12.7751 7.31929 12.6088 7.65875 12.5414C7.99822 12.474 8.35009 12.5086 8.66986 12.6407C8.98963 12.7729 9.26294 12.9967 9.45523 13.2838C9.64753 13.571 9.75016 13.9086 9.75016 14.2539C9.75016 14.717 9.56579 15.1611 9.2376 15.4886C8.90941 15.816 8.46429 16 8.00016 16ZM9.86683 8.92255C9.65869 9.01319 9.48158 9.16247 9.35724 9.35208C9.23289 9.54169 9.16672 9.76339 9.16683 9.98999C9.16683 10.2987 9.04391 10.5948 8.82512 10.8131C8.60633 11.0314 8.30958 11.154 8.00016 11.154C7.69074 11.154 7.394 11.0314 7.1752 10.8131C6.95641 10.5948 6.8335 10.2987 6.8335 9.98999C6.83339 9.3104 7.03202 8.64555 7.40504 8.07694C7.77806 7.50833 8.30925 7.06067 8.9335 6.78884C9.3191 6.62092 9.65202 6.35211 9.89703 6.01084C10.142 5.66958 10.29 5.26857 10.3253 4.85026C10.3606 4.43196 10.2818 4.01192 10.0974 3.63461C9.91298 3.2573 9.62974 2.93676 9.27768 2.70693C8.92561 2.47709 8.51782 2.34651 8.09745 2.32901C7.67709 2.3115 7.25981 2.40773 6.88977 2.60749C6.51974 2.80726 6.21073 3.10314 5.99544 3.4638C5.78016 3.82447 5.66661 4.2365 5.66683 4.65629C5.66683 4.96502 5.54391 5.2611 5.32512 5.4794C5.10633 5.6977 4.80958 5.82034 4.50016 5.82034C4.19074 5.82034 3.894 5.6977 3.67521 5.4794C3.45641 5.2611 3.3335 4.96502 3.3335 4.65629C3.33348 3.81682 3.56093 2.99296 3.99177 2.2719C4.4226 1.55084 5.0408 0.959409 5.78093 0.560197C6.52106 0.160986 7.35559 -0.0311541 8.1962 0.00411115C9.03682 0.0393764 9.85224 0.300736 10.5562 0.760528C11.2601 1.22032 11.8264 1.86144 12.195 2.61604C12.5637 3.37064 12.721 4.21064 12.6504 5.04715C12.5797 5.88366 12.2837 6.68555 11.7937 7.36796C11.3037 8.05038 10.6379 8.58676 9.86683 8.92255Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_14159_31522">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  },
);
